<div class="text-center position-relative p-5">
  @if (sessionExpiration()) {
      <h1 class="card-title h5 text-success mb-3">
          <fa-icon [icon]="faCircleCheck" aria-hidden="true"></fa-icon>
          <span class="ms-2" data-test="h1" i18n="@@page.login.success.h1">Authentication Success</span>
      </h1>

    <div class="text-body-secondary" i18n="@@page.login.success.message">
      Your session expires at {{ sessionExpiration() }}
    </div>
  } @else if (errorStatus()) {
      <h1 class="card-title h5 text-danger mb-3">
          <fa-icon [icon]="faTriangleExclamation" aria-hidden="true"></fa-icon>
          <span class="ms-2" data-test="h1" i18n="@@page.login.error.h1">Error</span>
      </h1>

    @if (errorStatus() === 404) {
      <div class="text-body-secondary mb-4" i18n="@@page.login.404.feature.message">
        This feature is for use when calling the Disney Support Center to verify your identity when directed to do so
        by the support representative.
      </div>
      <div class="text-body-secondary" i18n="@@page.login.404.message">
        If you receive this error while on the phone with the Support Center, please report this error to the support
        agent.
      </div>
    } @else {
      <div class="text-body-secondary" i18n="@@page.login.error.message">
        Something bad happened.<br />Try again or contact the help desk.
      </div>
    }
  } @else {
    <app-loading></app-loading>
  }
</div>
